"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconFullscreenClose = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconFullscreenClose = function IconFullscreenClose(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.003 2l-6.076 5.77V4.041h-1.26v5.77h6.077V8.616h-3.927l6.077-5.77zM4.178 15.442h3.926l-6.077 5.77.89.846 6.078-5.77v3.728h1.26v-5.77H4.178z",
    fillRule: "evenodd"
  }));
};
exports.IconFullscreenClose = IconFullscreenClose;